<template>
    <div class="ns-paginate2">
        <ns-paginate-header
            v-if="displayNsPaginateHeader"
            :url="applyFilters()"
            :model-name="baseUrl.split('/')[0]"
            :display-csv-button="displayCsvButton"
            :display-search-bar="displaySearchBar"
            :display-filters-button="allowFiltering"
            :table-title="tableTitle"
            :columnToHide="columnToHide"
            :listFieldToDisplay="listFieldToDisplay"
            @hideColumn="hideColumn"
            @reload="loadContent"
            @toggleFilters="displayFilter = !displayFilter"
            @triggerSearch="triggerSearch"
            :dark="dark"
        >
            <component :is="columnManager"></component>

        </ns-paginate-header>
        <div>
            <slot
                :reset="resetFilters"
                :applyFilters="loadContent"
                :filters-value="filtersValue"
                :allowedFilter="allowedFilter"
                :contents="contents"
                name="filter"
            >
                <ns-paginate-filters
                    ref="filterContainer"
                    v-if="displayFilter"
                    :search-text="searchText"
                    :filters-value="filtersValue"
                    :filters="filters"
                    :allowed-filter="allowedFilter"
                    :allow-wrap="allowWrap"
                    :select-width="selectWidth"
                    :display-advanced-filter="displayAdvancedFilter"
                    :advanced-filter="advancedFilter"
                    :window-width="windowWidth"
                    @loadContent="onFilterChange"
                    @resetFilters="resetFilters"
                >
                    <!-- A voir si avec Vue 3 on aura encore besoin de cette manip -->
                    <!-- pour récupérer un slot à un échelon n -->

                    <template slot="custom-input">
                        <slot name="custom-input">
                        </slot>
                    </template>
                </ns-paginate-filters>
            </slot>
        </div>
        <div class="list-container">
            <slot v-if="requestIsLoading" name="loader">
                <loader :dark="dark"></loader>
            </slot>
            <slot
                v-else
                :list="contents.results"
                :edit="showModalEditObject"
                name="list"
            >
                <ns-paginate-list
                    :element-loading-background="dark ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)'"
                    :infinite-scroll="infiniteScroll"
                    :contents="contents"
                    :list-field-to-display="listFieldToDisplay"
                    :custom-status="customStatus"
                    :operations-column="operationsColumn"
                    :can-edit-model="canEditModel"
                    :dark="dark"
                    :stripe="stripe"
                    :max-height="maxHeight"
                    :ordering-property="orderingProperty"
                    @sortChange="sortChange"
                    @showModalEditObject="showModalEditObject"
                    @on-fetch-more-data="loadContent(null, '', $event)"
                >
                    <template slot="custom-column">
                        <slot name="custom-column">
                        </slot>
                    </template>
                </ns-paginate-list>
            </slot>
        </div>

        <slot
            name="pagination"
            :contents="contents"
            :item-per-page="itemPerPage"
            :pages-size="pagesSize"
            :current-page="currentPage"
            :loadSpecificPage="loadSpecificPage"
            :onSizeChange="onSizeChange"
        >
            <ns-paginate-pagination
                v-if="!infiniteScroll"
                :contents="contents"
                :window-width="windowWidth"
                :item-per-page="itemPerPage"
                :pages-size="pagesSize"
                :current-page="currentPage"
                :auto-hide-paginator-if-one-page-only="autoHidePaginatorIfOnePageOnly"
                :dark="dark"
                @loadSpecificPage="loadSpecificPage"
                @onSizeChange="onSizeChange"
            ></ns-paginate-pagination>
        </slot>
    </div>
</template>

<script>

import nsPaginateHeader from './-new-ns-paginate-header.vue';
import nsPaginateFilters from './-new-ns-paginate-filters.vue';
import nsPaginateList from './-new-ns-paginate-list.vue';
import nsPaginatePagination from './-new-ns-paginate-pagination.vue';
import ModalDetail from './modal-detail.vue';
import ModalForm from '../modal-form.js';
import Loader from '../../partials/fundation-loader.vue';

import moment from 'moment';
import {mapGetters} from 'vuex';

export default {

    components: {
        nsPaginateHeader,
        nsPaginateFilters,
        nsPaginateList,
        nsPaginatePagination,
        Loader
    },

    props: {
        tableTitle: {
            type: String,
            default: ''
        },
        baseUrl: {
            type: String,
            required: true,
        },
        scoped: {
            type: Boolean,
            default: true,
        },
        filters: {
            type: Array,
            default: () => {
                return [];
            },
        },
        listFieldToDisplay: {
            type: Array,
            default: () => {
                return [];
            },
        },
        searchText: {
            type: String,
            default: undefined
        },
        customFiltersToApply: {
            type: Function,
            default: () => {
                return {};
            },
        },
        onResetFilters: {
            type: Function,
            default: () => {
                return {};
            },
        },
        allowWrap: {
            type: Boolean,
            default: false,
        },
        autoHidePaginatorIfOnePageOnly: {
            type: Boolean,
            default: true,
        },
        selectWidth: {
            type: Object,
            default () {
                return {
                    // xs: 24,
                    // sm: 12,
                    // md: 12,
                    // lg: 12,
                    // xl: 12
                };
            }, // valeur en %
        },
        displayCsvButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        displayAdvancedFilter: {
            type: Boolean,
            default: false,
        },
        displayNsPaginateHeader: {
            type: Boolean,
            default: true,
        },
        hideFiltersByDefault: {
            type: Boolean,
            default: false
        },
        displaySearchBar: {
            type: Boolean,
            required: false,
            default: true,
        },
        canEditModel: {
            type: Boolean,
            default: false,
        },
        model: {
            type: String,
            required: false,
            default: '',
        },
        overrideDisplay: {
            type: Object,
            default () {
                return {};
            },
        },
        extraHiddenKeys: {
            type: Array,
            default () {
                return [];
            },
        },
        customItemPageLength: {
            type: Number,
            required: false,
        },
        customStatus: {
            type: Object,
            required: false,
            default (){
                return {};
            },
        },
        operationsColumn: {
            type: Array,
            required: false,
            default (){
                return [];
            },
        },
        dark: {
            type: Boolean,
            required: false,
            default: false
        },
        stripe: {
            type: Boolean,
            required: false,
            default: false
        },
        // utilité de  ces 2 props a verifiée
        manageColumn: {
            type: Boolean,
            required: false,
            default: false,
        },
        columnManager: {
            type: Object,
            required: false,
            default: () => null
        },
        infiniteScroll: {
            type: Boolean,
            required: false,
            default: false
        },
        maxHeight: {
            type: String,
            required: false,
            default: '500'
        },
        noMoreMessage: {
            type: String,
            required: false,
            default: 'No more data',
        },
        autoReloadPeriod: {
            type: Number, // time in seconds
            required: false,
            default: 0,
        },
    },
    data: function() {
        return {
            autoReloadId: null,
            displayFilter: true,
            windowWidth: 0,
            currentPage: 1,
            fetchedFilters: null,
            contents: {},
            ordering: false,
            orderingProperty: {
                sign: '',
                property: ''
            },
            // c'est valeur sont encapsuler dans un object pour pouvoir etre surcharger en cas de slot voir: https://github.com/vuejs/vue/issues/5594
            filtersValue: {
                searchFilter: '',
                keysFilter: {},
            },
            regexDate: /(,?\d{4}-\d{2}-\d{2},?)/g,
            advancedFilter: false,
            itemPerPage: 2,
            requestIsLoading: true,
            advancedFiltersValue: [{
                valueToFilter: null,
                valueComparator: null,
                targetValue: null,
            }],
            columnToHide: [],
            nextUrl: '',
            // if nextUrl === '' alors on le set avec l'url de base
            // if nextUrl === null alors il n'y a plus de pages à fetcher.
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
        pagesSize() {
            let defaults = [10, 25, 50, 100];
            if(this.customItemPageLength && !defaults.includes(this.customItemPageLength)){
                defaults.push(this.customItemPageLength);
            }
            defaults.sort((a, b) => a - b);
            return defaults
        },

        allowedFilter() {
            let allowedFilters = {};
            for (let key in this.fetchedFilters) {
                let associatedFilter = this.filters.find((filter) => {
                    return filter.key === key;
                });
                if (associatedFilter !== undefined) {
                    let defaultValue = '';
                    if (typeof associatedFilter.defaultValue === 'string') {
                        defaultValue = this.fetchedFilters[key].includes(associatedFilter.defaultValue) ? associatedFilter.defaultValue : '';
                    } else if (associatedFilter.defaultValue instanceof Array) {
                        defaultValue = [];
                        defaultValue.push(...associatedFilter.defaultValue.filter((value) => {
                            return this.fetchedFilters[key].includes(value);
                        }));
                    }
                    let formatFunction = associatedFilter.hasOwnProperty('formatFunction') ? associatedFilter.formatFunction : (data) => {
                        return data;
                    };
                    allowedFilters[key] = {
                        list: this.fetchedFilters[key],
                        verbose: associatedFilter.verbose,
                        formatFunction: formatFunction,
                        defaultValue: defaultValue,
                    };
                }
            }
            return allowedFilters;
        },
        allowedFilterKeys() {
            return Object.keys(this.allowedFilter);
        },
        allowFiltering (){
            return this.filters.length > 0 || this.$slots['custom-input'] !== undefined;
        }
    },
    created() {
        this.itemPerPage = this.customItemPageLength || this.pagesSize[0];
    },
    mounted: function() {
        this.displayFilter = this.allowFiltering && !this.hideFiltersByDefault;
        this.restoreFilters();
        this.loadContent();
        this.setWindowWidthForNsPaginate();
        window.addEventListener('resize', this.setWindowWidthForNsPaginate);
        if(this.autoReloadPeriod > 0){
            this.autoReloadId = setInterval(() => {
                this.reloadWithoutDisplayLoader();
            }, this.autoReloadPeriod * 1000);
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.setWindowWidthForNsPaginate);
        clearInterval(this.autoReloadId);
    },

    methods: {
        reloadWithoutDisplayLoader () {
            this.loadContent(null, {page: this.currentPage}, null, false);
        },
        onFilterChange (){
            this.nextUrl = '';
            this.loadContent();
        },
        // For a future purpose
        hideColumn(column) {
            // transmettre les infos au body de la el-table
        },
        triggerSearch(value) {
            this.$set(this.filtersValue, 'searchFilter', value);
            this.nextUrl = '';
            this.loadContent();
        },
        setWindowWidthForNsPaginate() {
            this.windowWidth = window.innerWidth;
        },

        handleObjectEdition(val) {
            if (!this.model) {
                console.error(this.getVerbose('ns_paginate_modal_information_edit_props_error'));
                return;
            }
            return this.$store.dispatch(
                'patchItem', {
                    item: val,
                    model: this.model,
                }
            ).then(() => {
                this.$notify.success({
                    title: this.getVerbose('ns_paginate_modal_information_edit_success_title'),
                    message: this.getVerbose('ns_paginate_modal_information_edit_success_desc'),
                });
                this.loadContent();
            }).catch((error) => {
                this.$notify.warning({
                    title: this.getVerbose('ns_paginate_modal_information_edit_error_title'),
                    message: this.getVerbose('ns_paginate_modal_information_edit_error_desc'),
                });
                console.error(error);
            });
        },
        onSizeChange(val) {
            this.itemPerPage = val;
            this.loadContent();
        },
        loadContent(event, params={}, $state=null, displayLoader=true) {
            // quand la fonction est appelé depuis le button applyFilter le premier parametre passé est l'event du click du button
            // mais quand la fonction est appelé par 'loadSpecificPage' on veux passer 'params' en parametre
            if (this.ordering) {
                params.ordering = `${this.orderingProperty.sign}${this.orderingProperty.property}`;
            }
            let url = null, filterUrl = null;
            if(this.infiniteScroll){
                if(this.nextUrl === null){
                    $state.complete();
                    return;
                }
                if(this.nextUrl){
                    url = this.nextUrl;
                }else{
                    url = this.applyFilters(params, true);
                    filterUrl = `${this.baseUrl}${'sets/'}${this.applyFilterSeparator(this.customFiltersToApply())}`;
                }
            }else{
                url = this.applyFilters(params, true);
                filterUrl = `${this.baseUrl}${'sets/'}${this.applyFilterSeparator(this.customFiltersToApply())}`;
            }
            if (!url) return;
            // du coup le loader s'affiche au premier fetch même en mode infinite scroll et sinon tout le temps pour l'autre mode
            if(this.nextUrl === '' && displayLoader){
                this.requestIsLoading = true;
            }
            const scopes = (this.scoped) ? this.$store.state.api.scopes : {};
            const config = {
                headers: scopes
            };
            let promises = [this.$store.axios.get(url, config)];
            if (filterUrl) promises.push(this.$store.axios.get(filterUrl, config));
            Promise.all(promises).then((response) => {
                this.requestIsLoading = false;
                if(this.infiniteScroll){
                    if(this.nextUrl){
                        $state.loaded();
                        this.contents.results.push(...response[0].data.results);
                    }else{
                        this.$set(this, 'contents', response[0].data);
                        this.$set(this, 'fetchedFilters', response[1].data.sets);
                    }
                    this.nextUrl = response[0].data.next;
                }else{
                    this.$set(this, 'contents', response[0].data);
                    this.$set(this, 'fetchedFilters', response[1].data.sets);
                }
                // this.contents = response[0].data;
                this.resetHelpText();
                this.currentPage = params.hasOwnProperty('page') ? params.page : 1;

                // obliger de créer les clés pour 'keysFilter' sinon le select en multiple de element ui est pas content
                if (Object.keys(this.filtersValue.keysFilter).length === 0) {
                    let keys = Object.keys(this.allowedFilter);
                    let filters = {};
                    for (let key of keys) {
                        filters[key] = [];
                    }
                    this.$set(this.filtersValue, 'keysFilter', filters);
                }
                this.$emit('input', this.contents);
                if(response[0] && response[0].data && response[0].data.total_objects_count){
                    this.$emit('totalObjectsCount', response[0].data.total_objects_count);
                }
            }).catch((e) => {
                console.error(e);
            });
        },
        loadSpecificPage(number) {
            let params = {
                'page': number
            };
            this.loadContent(null, params);
        },
        resetHelpText() {
            for (let i = 0; i < this.advancedFiltersValue.length; i++) {
                if (this.$refs.helpFilter) {
                    this.$refs.helpFilter[i].classList.remove('helpFilterError');
                    this.$refs.helpFilter[i].innerText = '';
                }
            }
        },
        resetFilters() {
            this.nextUrl = '';
            for (let key in this.filtersValue.keysFilter) {
                if (this.filtersValue.keysFilter[key] instanceof Array) {
                    this.filtersValue.keysFilter[key] = [];
                } else {
                    this.filtersValue.keysFilter[key] = '';
                }
            }
            this.onResetFilters();
            this.filtersValue.searchFilter = '';
            if (Object.keys(this.allowedFilter).length > 0) {
                this.$refs.filterContainer.$refs.filterSelect.forEach((item) => {
                    item.resetCalled();
                });
            }
            this.advancedFiltersValue = [{
                valueToFilter: null,
                valueComparator: null,
                targetValue: null,
            }];
            this.loadContent();
        },
        getFiltersFromQueryParams(){
            if(!this.$route.query){
                return {};
            }
            let filters = {};
            for(let queryName in this.$route.query){
                let queryValue = this.$route.query[queryName];
                if(queryName.endsWith('__in')){
                    queryName = queryName.replace('__in', '');
                    queryValue = queryValue.split(',');
                }
                filters[queryName] = queryValue;
            }
            return filters;
        },
        getFilterValueFromParamOrDefault(filterName, filterDefaultValue=undefined){
            let value = filterDefaultValue;
            let filtersFromQueryParams = this.getFiltersFromQueryParams();
            if(filterName in filtersFromQueryParams){
                value = filtersFromQueryParams[filterName];
            }
            return this.formatFilterValue(value);
        },
        formatFilterValue(filterValue){
            if(filterValue !== undefined){
                if (typeof filterValue === 'string' && filterValue !== '') {
                    return [filterValue];
                } else if (filterValue instanceof Array) {
                    return filterValue;
                }
            }
            // default
            return [];
        },
        restoreFilters(){
            //restore filters from params
            if(!this.$route.query){
                return;
            }
            let filtersFromQueryParams = this.getFiltersFromQueryParams();
            for(let queryName in filtersFromQueryParams){
                let queryValue = filtersFromQueryParams[queryName];
                if(queryName in this.filtersValue.keysFilter){
                    this.$set(
                        this.filtersValue.keysFilter,
                        queryName,
                        this.formatFilterValue(queryValue)
                    );
                }
                // TODO Manage here if queryName in Advanced Filter
                else if(queryName in this.advancedFiltersValue){
                    console.warning('TODO init advancedFilter value');
                }
            }
        },
        setFilterInUriParams(filterToApply){
            // exclude some fields
            delete filterToApply.c_resp_page_size;
            delete filterToApply.c_resp_nested;

            let filters = {}
            for (let key in filterToApply) {
                let filterValue = filterToApply[key];
                // cast to string
                filters[key] = `${filterValue}`;
            }
            let query = {}
            if(this.$route.query){
                query = this.$route.query;
            }

            let filtersFromQueryParams = this.getFiltersFromQueryParams();

            for (let key in filtersFromQueryParams) {
                if(filterToApply[key] === undefined){
                    delete query[key]
                }
            }

            // Force tick to update query
            this.$router.replace({query: {}}).catch(e => {});
            this.$router.replace({query: {...query, ...filters}}).catch(e => {}).then(()=>{});
        },
        applyFilters(params = '', queryUpdate=false) {
            let additional = this.customFiltersToApply();
            additional['c_resp_page_size'] = this.itemPerPage;
            let url = this.baseUrl;
            let filterToApply = {
                search: this.filtersValue.searchFilter
            };
            // appeler seulement la premiière fois (car apres fetchedFilters contient la liste des filtres)/ Permet de mettre une valeur par défaut dans les filtres sélectionnable pas l'utilisateurs.
            if (this.fetchedFilters === null) {
                for (let filter of this.filters) {
                    this.$set(
                        this.filtersValue.keysFilter,
                        filter.key,
                        this.getFilterValueFromParamOrDefault(filter.key, filter.defaultValue)
                    );
                }
                this.fetchedFilters = {};
            }
            // ADD FILTER
            for (let key in this.filtersValue.keysFilter) {
                if (this.filtersValue.keysFilter[key].length > 0) {
                    let filterValue = this.filtersValue.keysFilter[key];
                    if (filterValue instanceof Array && filterValue.length > 1) {
                        filterToApply[`${key}__in`] = filterValue;
                    } else {
                        filterToApply[key] = filterValue;
                    }
                }
            }
            // ADD ADVANCED FILTER VALUE
            let hasError = false;
            if (this.advancedFilter && this.displayAdvancedFilter) {
                let count = 0;
                for (let item of this.advancedFiltersValue) {
                    let helpText = this.$refs.helpFilter[count];
                    let itemValues = Object.values(item);
                    if (itemValues.every((val) => val !== '' && val !== null)) {
                        hasError = this.checkAdvancedFilterValidation(item, helpText);
                        let checkedItem = this.handleDateCase(item);
                        filterToApply[`${checkedItem.valueToFilter}__${checkedItem.valueComparator}`] = checkedItem.targetValue;
                    } else {
                        helpText.innerText = this.getVerbose('advanced_filters_help_text');
                        helpText.classList.add('helpFilterNotice');
                    }
                    count++;
                }
            }
            if (hasError) return;
            filterToApply = Object.assign(filterToApply, additional, params);
            let urlParams = this.applyFilterSeparator(filterToApply);
            if(queryUpdate){
                this.setFilterInUriParams(filterToApply);
            }
            url = `${url}${urlParams}`;
            url = encodeURI(url);
            return url;
        },
        applyFilterSeparator(allFilters) {
            let urlParams = '';
            let count = 0;
            for (let filterKey in allFilters) {
                let filterValue = allFilters[filterKey];
                if (count === 0) {
                    urlParams += '?';
                } else {
                    urlParams += '&';
                }
                if (filterValue !== '') {
                    urlParams += `${filterKey}=${filterValue}`;
                }
                count++;
            }
            return urlParams;
        },
        checkAdvancedFilterValidation(item, helpText) {
            let hasError = false;
            if (item.targetValue.match(/[a-z]+/g)) {
                hasError = true;
                helpText.innerText = this.getVerbose('ns_paginate_advanced_filters_error_message_type');
            } else if (item.valueComparator === 'range') {
                if (!item.targetValue.match(this.regexDate) && !item.targetValue.match(/(\d+,\d+)/g)) {
                    hasError = true;
                    helpText.innerText = this.getVerbose('ns_paginate_advanced_filters_range_error_message_type');
                }
                if (item.targetValue.match(this.regexDate)) {
                    let dates = item.targetValue.split(',');
                    if (moment(dates[1]).isBefore(moment(dates[0]))) {
                        hasError = true;
                        helpText.innerText = this.getVerbose('ns_paginate_advanced_filters_range_error_message_date');
                    }
                }
            }
            if (hasError) helpText.classList.add('helpFilterError');
            return hasError;
        },
        handleDateCase(item) {
            // le greater than et lower than ne fonctionne pas avec les dates mais avec range on peux utiliser date,vide pour gt et vide,date pour lt
            // afin de faciliter l'utilisation à l'utilisateur, si celui-ci utilise un gt,lt,gte,lte avec une date j'envoie en range coté server
            let checkedItem = JSON.parse(JSON.stringify(item));
            if (checkedItem.targetValue.match(this.regexDate) && checkedItem.valueComparator !== 'range') {
                if (checkedItem.valueComparator === 'gt' || checkedItem.valueComparator === 'gte') {
                    checkedItem.targetValue = `${checkedItem.targetValue},`;
                    checkedItem.valueComparator = 'range';
                } else if (checkedItem.valueComparator === 'lt' || checkedItem.valueComparator === 'lte') {
                    checkedItem.targetValue = `,${checkedItem.targetValue}`;
                    checkedItem.valueComparator = 'range';
                }
            }
            return checkedItem;
        },
        sortChange(sortValue) {
            let sign = '';
            if (sortValue.order === 'descending') sign = '-';
            let fieldToDisplay = this.listFieldToDisplay.find((item) => item.key === sortValue.prop);
            let orderBy = fieldToDisplay ? fieldToDisplay.orderBy : sortValue.prop;
            this.$set(this, 'orderingProperty', {
                sign: sign,
                property: orderBy
            });
            this.ordering = true;
            this.loadContent(null, { 'page': this.currentPage });
        },
        showModalEditObject(object) {
            ModalForm.display(
                this,
                ModalDetail, {
                    attrs: object,
                    customClassName: 'modal-edit',
                    overrideDisplay: this.overrideDisplay,
                    store: this.$store,
                    extraHiddenKeys: this.extraHiddenKeys,
                    getVerbose: this.getVerbose,
                    canEdit: this.canEditModel,
                },
                this.getVerbose('ns_paginate_modal_information_title'),
                this.handleObjectEdition,
            );

        }
    },

};
</script>

<style lang="scss">

.ns-paginate2 {
    .ns-paginate-header {
        padding: 30px;
        .title {
            font-size: 30px;
            color: #231F20;
            &.dark-theme {
                color: #BBBBBB;
            }
        }
        .ns-paginate-header-container {
            display: flex;
            justify-content: flex-end;
            .ns-paginate-search-input{
                width: 100%;
                margin-top: 2px;
                margin-right: -1px;
                .searchbar {
                    input, .el-input-group__append {
                        border: none;
                        border-radius: 0;
                        border-bottom:1px solid #696969;
                        background-color: transparent;
                        color: #696969;
                    }
                    input::placeholder {
                        color: #696969;
                    }
                    i:hover {
                        cursor: pointer;
                    }
                }
            }
            .options {
                margin-left: 15px;
                color: #6C6C6C;
                background-color: transparent;
                height: 40px;
                .options-button {
                    color: #696969;
                }
                .el-submenu__title {
                    background-color: transparent;
                    border: none;
                    padding: 0;
                    height: 40px;
                    .el-submenu__icon-arrow {
                        display: none;
                    }
                }
            }
        }
    }
    .ns-paginate-options-menu {
        color: #6C6C6C;
        .el-menu {
            padding: 0;
        }
        .el-menu--horizontal {
            left: unset !important;
            top: 0 !important;
            right: 200px !important;
        }
        .el-menu-item, .el-submenu {
            display: flex;
            align-items: center;
            i {
                margin-right: 8px;
            }
            .el-submenu__title {
                .el-submenu__icon-arrow {
                    display: none;
                }
            }
        }
        .el-menu-item.is-active {
            color: #909399 !important;
        }
        .el-menu-item:hover {
            background-color: #ECF5FE;
            color: #89C3F9 !important;
            i {
                color: #89C3F9 !important;
            }
        }
    }
    .ns-paginate-options-dropdown {
        .el-dropdown-menu__item {
            display: flex;
            align-items: center;
            i {
                margin-right: 11px;
                font-size: 16px;
            }
        }
    }
    .ns-paginate-table {
        thead {
            tr {
                th {
                    background-color: rgba(245, 247, 251, 0.5);
                }
            }
        }
        .el-table__row.hover-row {
            td {
                background-color: #F9FAFC;
            }
        }
        &.dark-theme {
            .el-loading-mask {
                background-color: rgba(82, 82, 82, .9);
            }
            .el-table__empty-block {
                background-color: #2E3035;
                color: #EAEBEF;
            }
            &::before {
                background-color: #2E3035;
            }
            .el-table__header-wrapper {
                background-color: #57595D;
                border-bottom: 1px solid #393B40;
            }
            thead {
                tr {
                    th {
                        color: #EAEBEF;
                        background-color: #57595D;
                        border: none;
                    }
                }
            }
            .el-table__row {
                td {
                    color: #EAEBEF;
                    background-color: #2E3035;
                    border-color: #393B40;
                }
                &:hover {
                    td {
                        background-color: #37393D;
                    }
                }
            }
        }
    }
    .ns-paginate-header {
        padding: 30px;
        .title {
            font-size: 30px;
            color: #231F20;
        }
        .ns-paginate-header-container {
            display: flex;
            .searchbar {
                input, .el-input-group__append {
                    border: none;
                    border-radius: 0;
                    border-bottom: 1px solid #696969;
                    background-color: transparent;
                    color: #696969;
                }
            }
            .options {
                margin-left: 15px;
                .options-button {
                    color: #696969;
                }
            }
        }
    }
    .list-container {
        padding: 0 30px 30px;
    }
}

.el-message-box__wrapper {
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate2/index.vue